import React from 'react'

import { Paper } from 'material-ui'

import MemberIcon, { IconSize } from './MemberIcon'

class TeamTilesView extends React.Component {

  getStyleFromRole(member) {
    return member.access && member.access.toLowerCase() === 'admin'
      ? styles.highlightRoleStyles
      : styles.normalRoleStyles
  }

  render() {
    return (
      <div
        style={styles.tilesViewStyles}>
        {this.props.list.map(member =>
          <div style={{ flexGrow: 0, flexShrink: 0, padding: 10}} key={member.userId}>
            <Paper
              onTouchTap={() => this.props.onMemberSelected(member.userId)}
              style={styles.memberCardStyles}>
              <MemberIcon member={member}
                size={IconSize.Large}
                style={styles.memberIconStyles}/>
              <div style={styles.divider}>
              </div>
              <div style={styles.nameStyles}>
                {member.displayName}
              </div>
              <div style={styles.phoneStyles}>
                {member.userId}
              </div>
              <div style={this.getStyleFromRole(member)}>
                {member.role}
              </div>
            </Paper>
          </div>
        )}
      </div>
    )
  }
  
}

const styles = {

  nameStyles: {
    fontSize: 14,
    fontWeight: 500,
    color: '#757575'
  },
  phoneStyles: {
    fontSize: 14,
    color: '#bdbdbd',
    marginTop: 6
  },
  normalRoleStyles: {
    fontSize: 14,
    fontWeight: 500,
    color: '#bdbdbd',
    marginTop: 4
  },
  highlightRoleStyles: {
    fontSize: 14,
    fontWeight: 500,
    color: '#356992',
    marginTop: 4    
  },
  tilesViewStyles: {
    marginRight: 40,
    marginLeft: 40,
    display: 'flex',
    flexFlow: 'row wrap',
    alignItems: 'flex-start'
  },
  memberCardStyles: {
    width: 147,
    height: 217,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    borderRadius: 6,
    alignItems: 'center',
    cursor: 'pointer'
  },
  memberIconStyles: {
    marginTop: 18,
    marginBottom: 18
  },
  divider: {
    borderBottom: '1px solid #e2e2e2',
    width: 120,
    marginBottom: 18
  }

}

export default TeamTilesView


// WEBPACK FOOTER //
// ./src/team/TeamTilesView.js